export const WITHDRAWAL={
    COMPLETED:1,
    PENDING:2,

    };
export const CHANGEPASSWORD={
    RESETPASSWORD_UNSET:0,
    RESETPASSWORD_SET:1,
    
}

export const CUSTOM_FIELD={
    TEXT: 1,
    DROPDOWN: 2,
    NUMERIC: 3,
    DATE: 4,
    TEXTAREA: 5,
    MULTISELECT: 6,
    FILE: 7,
}

export const PRODUCT = {
    
    NORMAL: 1,
    DIGITAL: 2,
    DRAFT: 0,
    SUBMIT: 1,
    FILETYPES:[".jpg", ".jpeg", ".png", ".gif", ".webp", ".tiff", ".bmp"],
    ACTIVE:1,
    PENDING:2,
    REJECTED:3,
    ARCHIVED:4,
    DELETED:5,
    ALL:6,
}


export const VENDOR_TICKET ={
    AWAITING_ADMIN_REPLY : 1,
    AWAITING_VENDOR_REPLY : 2,
    CLOSED : 3
}

export const RETURN_REQUEST ={
    REQUESTED:1,
    OPEN:2,
    DECLINED:3,
    CLOSED:4,
    DISPOSED:1,
}

export const SERVICE = {
    FILETYPES:["jpg","jpeg","gif","webp","tiff","bmp","png","pdf","odt","mp3","aac","wav","webm","mp4","mkv","avi"],
    DRAFT: 0,
    ACTIVE:1,
    PENDING:2,
    REJECTED:3,
    ARCHIVED:4,
    DELETED:5,
}

export const PROFILE = {
    IS_INCOMPLETE : 0,
    IS_COMPLETE : 1
}
